import { css } from "@stubhub/broadway-foundation/css";

const shimmerBase = {
  backgroundImage:
    "[linear-gradient(135deg, var(--bway-colors-bg-surface-stronger) 25%, var(--bway-colors-bg-surface-strong) 50%, var(--bway-colors-bg-surface-stronger) 75%)]",
  backgroundSize: "[200% 200%]",
  animationName: "[shimmer]",
  animationDuration: "[1.5s]",
  animationTimingFunction: "[linear]",
  animationIterationCount: "[infinite]",
  height: "[120px]",
  width: "full",
  borderRadius: "primitives.50",
} as const;

export const seoTableSkeleton = css(shimmerBase);
